export default {
  render: () => null,
};
